<template>
  <div style="padding: 0 10px 10px">
    <!--    <div-->
    <!--      v-for="(item, index) in stuCardList"-->
    <!--      :key="index"-->
    <!--      class="row-box"-->
    <!--      style="background-color: #fff"-->
    <!--    >-->
    <!--      <div style="width: 100%; margin: 0 0 15px 15px">-->
    <!--        <div class="title-0">{{ item.title }}</div>-->
    <!--      </div>-->
    <!--      <div class="flex-align-center" style="flex-wrap: wrap">-->
    <!--        <div-->
    <!--          v-for="(sItem, index) in item.list"-->
    <!--          :key="index"-->
    <!--          class="card-item"-->
    <!--          :style="{-->
    <!--            width: index % 5 === 0 ? (4 / 16) * 100 + '%' : (3 / 16) * 100 + '%',-->
    <!--          }"-->
    <!--        >-->
    <!--          <div-->
    <!--            class="key-point-item flex-between"-->
    <!--            :style="{ backgroundColor: sItem.backgroundColor || '#fff' }"-->
    <!--          >-->
    <!--            <div>-->
    <!--              <div-->
    <!--                class="number-value"-->
    <!--                :style="{ marginTop: '10px', color: sItem.backgroundColor ? '#fff' : '#595959' }"-->
    <!--              >-->
    <!--                {{ sItem.value }}-->
    <!--              </div>-->
    <!--              <div-->
    <!--                :style="{ marginTop: '20px', color: sItem.backgroundColor ? '#fff' : '#595959' }"-->
    <!--              >-->
    <!--                {{ sItem.label }}-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div v-show="sItem?.value2 !== undefined">-->
    <!--              <div-->
    <!--                class="number-value"-->
    <!--                :style="{ marginTop: '10px', color: sItem.backgroundColor ? '#fff' : '#595959' }"-->
    <!--              >-->
    <!--                {{ sItem.value }}-->
    <!--              </div>-->
    <!--              <div-->
    <!--                :style="{ marginTop: '20px', color: sItem.backgroundColor ? '#fff' : '#595959' }"-->
    <!--              >-->
    <!--                {{ sItem.label }}-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="row-box flex-align-center" style="flex-wrap: wrap; padding: 0">
      <div v-for="(item, index) in pieChartList" :key="index" class="pie-item">
        <div class="pie-content">
          <div class="title-0">{{ item.title }}</div>
          <div v-if="item.chartData" style="width: 100%" class="flex-center">
            <PieChart
              :color="['#009DFF', '#13B999', '#FA9600', '#EB3D2F']"
              style="width: 60%; height: 240px; margin-top: 20px"
              :radius="['50%', '70%']"
              :dataSource="item.chartData"
              :pieText="item.pieText"
            />
            <div>
              <div v-for="(cItem, cIndex) in item.legendArr || item.chartData">
                <div>
                  <span style="font-size: 15px; color: #666">
                    {{ cItem.name }}
                  </span>
                  <span style="margin-left: 10px; font-size: 28px; color: #333; font-weight: bold">
                    <CountAnimation :end-val="cItem.value" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="flex-between" style="flex-wrap: wrap">
            <div
              v-for="(tItem, tIndex) in item.textData"
              :key="tIndex"
              style="width: 50%; margin-top: 40px"
            >
              <div style="font-size: 28px; color: #333; font-weight: bold">
                <CountAnimation :end-val="tItem.value" />
              </div>
              <div style="margin-top: 16px; font-size: 15px">{{ tItem.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row-box" style="background-color: #fff; padding: 20px 30px">
      <ClassTeacherWork />
    </div>
  </div>
</template>

<script>
import CountAnimation from '@/components/CountAnimation'
import { getAction } from '@api/manage'
import PieChart from '@/components/echartZyz/components/PieChart'
import ClassTeacherWork from './components/ClassTeacherWork.vue'

export default {
  name: 'MoralEducation',
  components: {
    CountAnimation,
    // CreatePlan,
    PieChart,
    ClassTeacherWork,
  },
  props: {
    modeType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      queryParam: {},
      loading: true,
      headCardList: [
        {
          title: '今日校园动态',
          backgroundColor: '#009cfa',
          contentList: [
            {
              label: '心情提醒',
              value: 0,
            },
            {
              label: '班级提醒',
              value: 0,
            },
            {
              label: '心情记录',
              value: 0,
            },
          ],
        },
        {
          title: '今日校园心情',
          backgroundColor: '#23cdad',
          contentList: [
            {
              label: '正常人数',
              value: 0,
            },
            {
              label: '提醒人数',
              value: 0,
            },
            {
              label: '关爱人数',
              value: 0,
            },
          ],
        },
        {
          title: '学校基本信息',
          backgroundColor: '#725be9',
          contentList: [
            {
              label: '学生人数',
              value: 0,
            },
            {
              label: '心理老师访问次数',
              value: 0,
            },
            {
              label: '教师访问次数',
              value: 0,
            },
          ],
        },
      ],
      // 重点关爱学生/小叮当提醒学生
      stuCardList: [
        {
          title: '重点关爱学生',
          list: [
            {
              value: 0,
              key: 'zgaCnt',
              label: '重点关爱学生数',
              backgroundColor: '#F66860',
              value2: 0,
              key2: 'zgaCnt2',
              label2: '已关爱学生次数',
            },
            {
              value: 0,
              key: 'pgCnt',
              label: '待评估学生数',
            },
            {
              value: 0,
              key: 'txCnt',
              label: '待危机干预学生数',
            },
            {
              value: 0,
              key: 'txFdyyCnt',
              label: '心理辅导预约',
              backgroundColor: '#1783E8',
            },
            {
              value: 0,
              key: 'fdtzCnt ',
              label: '已辅导学生数',
            },
            {
              value: 0,
              key: 'txCnt',
              label: '待危机干预学生数',
            },
            {
              value: 0,
              key: 'txFdyyCnt',
              label: '心理辅导预约',
              backgroundColor: '#1783E8',
            },
            {
              value: 0,
              key: 'fdtzCnt ',
              label: '已辅导学生数',
            },
          ],
        },
        {
          title: '小叮当提醒学生',
          list: [
            {
              value: 100,
              label: '提醒学生',
              backgroundColor: '#1783E8',
            },
            {
              value: 0,
              label: '已查看学生数',
            },
            {
              value: 0,
              label: '已归档学生数',
            },
          ],
        },
      ],
      keyPointStuList: [
        {
          value: 60,
          label: '重点关爱学生数',
        },
        {
          value: 0,
          label: '已查看学生数',
        },
        {
          value: 0,
          label: '待评估学生数',
        },
        {
          value: 0,
          label: '待干预学生数',
        },
        {
          value: 0,
          label: '待家校沟通学生数',
        },
        {
          value: 0,
          label: '已归档学生数',
        },
      ],
      remindStuList: [
        {
          value: 100,
          label: '提醒学生',
        },
        {
          value: 0,
          label: '已查看学生数',
        },
        {
          value: 0,
          label: '已归档学生数',
        },
      ],
      planList: [],
      pieChartList: [
        {
          title: '校园学生心理健康概况',
          chartData: [
            { value: 0, name: '正常学生人数' },
            { value: 0, name: '一类学生人数' },
            { value: 0, name: '二类学生人数' },
            { value: 0, name: '三类学生人数' },
          ],
          pieText: [],
        },
        {
          title: '重点关爱学生概况',
          chartData: [
            { value: 0, name: '已关爱学生数' },
            { value: 0, name: '待关爱学生数' },
          ],
          legendArr: [],
          pieText: [],
        },
        {
          title: '小叮当提醒学生概况',
          chartData: [
            { value: 0, name: '已处理提醒数' },
            { value: 0, name: '未处理提醒数' },
          ],
          pieText: [],
        },
        {
          title: '心理健康工作统计概况',
          textData: [
            { value: 0, name: '心理测评次数' },
            { value: 0, name: '心理辅导次数' },
            { value: 0, name: '家访次数' },
            { value: 0, name: '班主任沟通次数' },
          ],
        },
      ],
    }
  },
  created() {
    this.getHeadCardData()
    this.getRectorWorkbench()
    this.getPlanList()
  },
  methods: {
    getHeadCardData() {
      // 校园动态
      this.loading = true
      getAction('/statistic/todaySchoolDynamic').then((res) => {
        if (res.success) {
          const { mood_warn, class_warn, mood_records } = res.result
          const contentList = [
            {
              label: '心情提醒',
              value: mood_warn || 0,
            },
            {
              label: '班级提醒',
              value: class_warn || 0,
            },
            {
              label: '心情记录',
              value: mood_records || 0,
            },
          ]
          this.$set(this.headCardList[0], 'contentList', contentList)
        }
      })
      // 校园心情
      getAction('/statistic/todaySchoolMood', this.queryParam).then((res) => {
        if (res.success) {
          const { normalPeople, needCarePeople, carePeople } = res.result
          const contentList = [
            {
              label: '正常人数',
              value: normalPeople || 0,
            },
            {
              label: '提醒人数',
              value: needCarePeople || 0,
            },
            {
              label: '关爱人数',
              value: carePeople || 0,
            },
          ]
          this.$set(this.headCardList[1], 'contentList', contentList)
        }
      })
      // 学校基本信息
      getAction('/statistic/schoolBasicInfo', this.queryParam).then((res) => {
        if (res.success) {
          const { studentCount, teacherCount, parentVisitAvg } = res.result
          const contentList = [
            {
              label: '学生人数',
              value: studentCount || 0,
            },
            {
              label: '心理老师访问次数',
              value: parentVisitAvg || 0,
            },
            {
              label: '教师访问次数',
              value: teacherCount || 0,
            },
          ]
          this.$set(this.headCardList[2], 'contentList', contentList)
        }
      })
      setTimeout(() => {
        this.loading = false
      }, 200)
    },
    getRectorWorkbench() {
      getAction('/home/rectorWorkbench').then((res) => {
        if (res.success) {
          console.log('res--', res.result)
          const {
            normalStudentCnt,
            careList1StudentCnt,
            careList2StudentCnt,
            careList3StudentCnt,
            ygaStudentCnt,
            dgaStudentCnt,
            zgaCnt,
            txYfdCnt,
            txUndoCnt,
            planCnt,
            fdCnt,
            jxgtCnt,
            bzrgtCnt,
          } = res.result
          const chartData0 = [
            { value: normalStudentCnt, name: '正常学生人数' },
            { value: careList1StudentCnt, name: '一级学生人数' },
            { value: careList2StudentCnt, name: '二级学生人数' },
            { value: careList3StudentCnt, name: '三级学生人数' },
          ]
          const total0 = chartData0.reduce((acc, cur) => acc + cur.value, 0)
          const chartData1 = [
            { value: ygaStudentCnt, name: '已关爱学生数' },
            { value: dgaStudentCnt, name: '待关爱学生数' },
          ]
          const legendArr1 = [
            { value: ygaStudentCnt, name: '已关爱学生数' },
            { value: dgaStudentCnt, name: '待关爱学生数' },
            { value: zgaCnt, name: '总关爱学生次数' },
          ]
          const total1 = chartData1.reduce((acc, cur, index) => acc + cur.value, 0)
          const chartData2 = [
            { value: txYfdCnt, name: '已处理提醒数' },
            { value: txUndoCnt, name: '未处理提醒数' },
          ]
          const total2 = chartData2.reduce((acc, cur) => acc + cur.value, 0)
          const textData = [
            { value: planCnt, name: '心理测评次数' },
            { value: fdCnt, name: '心理辅导次数' },
            { value: jxgtCnt, name: '家访次数' },
            { value: bzrgtCnt, name: '班主任沟通次数' },
          ]
          this.$set(this.pieChartList[0], 'chartData', chartData0)
          this.$set(this.pieChartList[0], 'pieText', [total0, '总人数'])
          this.$set(this.pieChartList[1], 'chartData', chartData1)
          this.$set(this.pieChartList[1], 'legendArr', legendArr1)
          this.$set(this.pieChartList[1], 'pieText', [total1, '总人数'])
          this.$set(this.pieChartList[2], 'chartData', chartData2)
          this.$set(this.pieChartList[2], 'pieText', [total2, '总提醒数'])
          this.$set(this.pieChartList[3], 'textData', textData)
        }
      })
    },
    getPlanList() {
      this.planList = []
      getAction('/schoolEvaluationPlan/list', { pageNo: 1, pageSize: 5 }).then((res) => {
        if (res.success) {
          const planList = res.result.records.map((item) => ({
            ...item,
            id: item.id,
            title: item.name,
            status: item.status,
            time: item.createTime,
            rate: (item.finishStudentNum / item.planStudentNum).toFixed(2) * 100,
            color: '#1783E8',
            tag: 0,
          }))
          this.planList.push(...planList)
        }
      })
      getAction('/schoolActivityPlan/list', { pageNo: 1, pageSize: 5 }).then((res) => {
        if (res.success) {
          console.log('活动计划：', res.result)
          const activityPlanList = res.result.records.map((item) => ({
            ...item,
            id: item.id,
            title: item.title,
            status: item.status,
            time: item.createTime,
            rate: (item.finishClassNum / item.planClassNum).toFixed(2) * 100,
            color: '#1783E8',
            tag: 1,
          }))
          this.planList.push(...activityPlanList)
        }
      })
      console.log('计划列表：', this.planList)
    },
    changModeType() {
      this.$emit('changeModeType', this.modeType)
    },
    createPlan() {
      this.$refs.createPlanRef.showModal({})
    },
  },
}
</script>
<style scoped lang="less">
.row-box {
  padding: 20px 10px;
  margin-bottom: 10px;
  border-radius: 8px;
}
.pie-item {
  box-sizing: border-box;
  width: 50%;
  height: 370px;
  padding: 10px 12px;
  .pie-content {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 20px 30px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    background-color: #fff;
  }
  &:nth-child(odd) {
    padding-left: 0;
  }
  &:nth-child(even) {
    padding-right: 0;
  }
}
.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.head-card-box {
  min-height: 135px;
  color: #fff;
  border-radius: 15px;
  padding: 0px 20px;
}
.card-content {
  display: flex;
  justify-content: space-between;
  .card-item {
    // flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .item-value {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 2px;
    }
    .item-desc {
      font-size: 14px;
    }
  }
}
.card-item {
  padding: 0 15px;
  margin-bottom: 20px;
}
.key-point-item {
  padding: 20px 30px;
  height: 140px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}
.number-value {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  border-radius: 5px;
}
.plan-card {
  margin-bottom: 20px;
  /deep/ .ant-card-body {
    padding: 12px;
  }
  .plan-card-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
